import autobind from 'autobind-decorator';
import { markRaw } from '#imports';
import { Inject, Injectable, forwardRef } from '@kaokei/use-vue-service';
import { uploadImFile } from '@core/api/im';

@Injectable()
export class ImageActionService {
  public visible = false;

  @autobind
  public toggleVisible() {
    this.visible = !this.visible;
  }

}
